<template>
  <section class="bx-search__header bx-typo--search-header bx-filters bx-filters--searchandfilters">
    <div>
      <a :href="shortLink.url"
         class="bx-js-active bx-typo--bold">
        {{ shortLink.text }}
      </a>
    </div>
    <span v-if="headline"
          class="bx-typo--h3">
      {{ headline }}
    </span>
  </section>
</template>

<script>

export default {
  props: {
    headline: {
      type: String,
      default: ''
    },
    shortLink: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
